module.exports = __webpack_public_path__ + "media/loans/federal-building-01b9a11d.svg";